// extracted by mini-css-extract-plugin
export default {"container":"TextEllipsis-module--container--LAKWe"};